<template>
  <div id="index" ref="appRef">
    <div style="width: 100%; height: 100%" v-if="loading">
      <dv-loading v-if="loading">数据加载中...</dv-loading>
    </div>
    <div class="bg" v-else>
      <div class="app-container host-body">
        <div class="top-notice-con">
          <div class="title-con" shadow="never">
            <el-image class="notice-icon" :src="require('@/assets/icons/notice-icon.png')" fit="fit"/>
            <span class="notice-title">欢迎来到萌神兽水育馆门店ERP系统</span>
          </div>
          <el-button v-if="marketRuleFlag" type="primary" class="operator-btn" style="margin-left: 20px" @click="openMarket()">营销链接制作</el-button>
          <el-button type="primary" class="operator-btn" style="margin-left: 20px" @click="openRongLian()">在线客服</el-button>
          <!-- <el-button v-if="userRole=='superadmin'" type="primary" class="operator-btn" style="margin-left: 20px" @click="openRongLian()">在线客服</el-button> -->
          <!-- <el-button v-if="userRole=='adminWorker'" type="primary" class="operator-btn" style="margin-left: 20px" @click="openRongLian()">在线客服</el-button> -->
        </div>
        <div class="body-box">
          <!-- 第一行 -->
          <div class="content-box-top">
            <topLeft :cdata="cdata"/>
            <topRight :cdata="cdata"/>
          </div>
          <!-- 第一行 -->
          <div class="content-box-center">
            <centerLeft :cdata ="cdata"/>
            <centerCenter :cdata ="cdata"/>
            <centerRight :cdata ="cdata"/>
          </div>
          <!-- 第一行 -->
          <div class="content-box-bottom">
            <bottomLeft :cdata ="cdata"/>
            <bottomCenter :cdata ="cdata"/>
            <bottomRight/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {rongLianToken} from "../../api/storeAdmin";
  import drawMixin from "../../utils/drawMixin";
  import topLeft from '../data/top/topLeft'
  import topRight from '../data/top/topRight'
  import centerLeft from '../data/center/centerLeft'
  import centerCenter from '../data/center/centerCenter'
  import centerRight from '../data/center/centerRight'
  import bottomLeft from '../data/bottom/bottomLeft'
  import bottomCenter from '../data/bottom/bottomCenter'
  import bottomRight from '../data/bottom/bottomRight'
  import globaldata from "../../utils/globaldata";
  import {getHomeData} from "@/api/storeFront";
  import { getToken } from '@/utils/auth'
  export default {
    name: 'home',
    mixins: [ drawMixin ],
    data() {
      return {
        cdata:{},
        loading: true,
        marketWebUrl: process.env.MARKET_WEB_URL,
        ronglianWebUrl: process.env.RONGLIAN_WEB_URL,
        userId: globaldata.getAdminStore().id,
        marketRuleFlag:globaldata.getAdminStore().marketRuleFlag,
        userRole:globaldata.getAdminStore().userRole,
        storeFrontId:globaldata.getAdminStore().storeFrontId,
      }
    },
    components: {
      topLeft,
      topRight,
      centerLeft,
      centerCenter,
      centerRight,
      bottomLeft,
      bottomCenter,
      bottomRight,
    },
    created(){
      let param = {
        storeFrontId:globaldata.getAdminStore().storeFrontId
      }
      if(param.storeFrontId != null){
        getHomeData(param).then(response =>
          {
            this.cdata = response.data;
            this.cancelLoading()
          })
      }else{
        this.cancelLoading()
      }
    },
    beforeDestroy() {

    },
    methods:{
      openMarket(){
        let mytoken = getToken();
        window.open(this.marketWebUrl+'?token='+mytoken+'&userId='+this.userId, '_blank');
      },

      /**
       *
       */
      cancelLoading() {
        setTimeout(() => {
          this.loading = false;
        }, 1000)
      },
      openRongLian(){
        let param = {
          storeFrontId:globaldata.getAdminStore().storeFrontId
        }
        rongLianToken(param).then(response =>
        {
          if(response.code === 20000){
            let data = response.data
            window.open(this.ronglianWebUrl+'?token='+data)
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/_variables.scss';
  @import '@/assets/scss/index.scss';
  @import '@/assets/scss/home.scss';
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue